export const UserActivityEvents = {
  snapshot: 'activity.snapshot',
  updated: 'activity.updated',
  loggedOut: 'activity.logged-out'
} as const;

export const UserActivityCommands = {
  push: 'activity.push',
  forceLogout: 'activity.force-logout'
} as const;
